import axios from "./http";

const fetchJobApplications = (payload) => {
  return axios.get(
    `api/JobApplications/GetJobApplications?keyword=${payload.keyword}&page=${payload.page}&status=${payload.status}`,
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
    }
  );
};

const fetchJobTypes = (payload) => {
  return axios.get(`api/Selections/GetJobTypes?keyword=${payload.keyword}&page=${payload.page}`, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchJobApplication = (payload) => {
  return axios.post("api/JobApplications/GetJobApplication", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchTotalJobApplicationByStatus = (payload) => {
  return axios.post(
    "api/JobApplications/GetTotalJobApplicationByStatus",
    payload,
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
    }
  );
};

const fetchTalents = (payload, context) => {
  return axios.post(`api/Candidate/GetCandidates?keyword=${payload.keyword}&page=${payload.page}`, context, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchEmployees = (payload) => {
  return axios.get(
    `api/UserManagement/GetEmployees?keyword=${payload.keyword}&page=${payload.page}&status=${payload.status}`,
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
    }
  );
};

const fetchTotalEmployee = (payload) => {
  return axios.get(
    `api/UserManagement/GetTotalEmployee?status=${payload.status}`,
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
    }
  );
};

const fetchEmployers = (payload) => {
  return axios.get(`api/Employers/GetEmployers?keyword=${payload.keyword}&page=${payload.page}&status=${payload.status}`, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchEmployer = (payload) => {
  return axios.post("api/Employers/GetEmployer", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchPendingEmployer = (payload) => {
  return axios.post("api/Employers/GetPendingEmployer", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchTotalEmployer = (payload) => {
  return axios.get(`api/Employers/GetTotalEmployer?status=${payload.status}`, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchEmployee = (payload) => {
  return axios.post("api/UserManagement/GetEmployee", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const createPackage = (payload) => {
  return axios.post("api/CreditPackage/CreatePackage", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const updatePackage = (payload) => {
  return axios.post("api/CreditPackage/UpdatePackage", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const deletePackage = (payload) => {
  return axios.post(`api/CreditPackages/DeletePackage?id=${payload.package_id}`, payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchCreditPackage = (payload) => {
  return axios.post("api/CreditPackages/GetCreditPackage", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchCreditPackages = (payload) => {
  return axios.get(
    `api/CreditPackages/GetCreditPackages?keyword=${payload.keyword}&page=${payload.page}&status=${payload.status}`,
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
    }
  );
};

const fetchActiveCreditPackages = (payload) => {
  return axios.get("api/CreditPackages/GetActiveCreditPackages", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchCreditPackagesList = (payload) => {
  return axios.get("api/CreditPackages/GetCreditPackages", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchTotalCreditPackage = (payload) => {
  return axios.get(
    `api/CreditPackages/GetTotalCreditPackage?status=${payload.status}`,
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
    }
  );
};

const fetchArticles = (payload) => {
  return axios.get(
    `api/Article/GetArticles?keyword=${payload.keyword}&page=${payload.page}&status=${payload.status}`,
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
    }
  );
};

const fetchArticle = (payload) => {
  return axios.post("api/Article/GetArticle", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const createArticle = (payload) => {
  return axios.post("api/Article/CreateArticle", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const updateArticle = (payload) => {
  return axios.post("api/Article/UpdateArticle", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const deleteArticle = (payload) => {
  return axios.post(`api/Article/DeleteArticle?id=${payload.id}`, payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchTotalArticles = (payload) => {
  return axios.post("api/Article/GetTotalArticlesByStatus", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchTotalSpecialization = (payload) => {
  return axios.get("api/Selections/GetTotalSpecialization", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchTotalPositionLevel = (payload) => {
  return axios.get("api/Selections/GetTotalPositionLevel", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchTotalIndustry = (payload) => {
  return axios.get("api/Selections/GetTotalIndustry", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchTotalDressCode = (payload) => {
  return axios.get("api/Selections/GetTotalDressCode", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchTotalJobType = (payload) => {
  return axios.get("api/Selections/GetTotalJobType", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchTotalCompanySize = (payload) => {
  return axios.get("api/Selections/getTotalCompanySize", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchTotalSpokenLanguage = (payload) => {
  return axios.get("api/Selections/getTotalSpokenLanguage", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchTotalQualification = (payload) => {
  return axios.get("api/Selections/getTotalQualification", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchSpecializations = (payload) => {
  return axios.get(`api/Selections/getSpecializations?keyword=${payload.keyword}&page=${payload.page}`, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchSpokenLanguages = (payload) => {
  return axios.get(`api/Selections/getSpokenLanguages?keyword=${payload.keyword}&page=${payload.page}`, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchPositionLevels = (payload) => {
  return axios.get(`api/Selections/getPositionLevels?keyword=${payload.keyword}&page=${payload.page}`, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchIndustries = (payload) => {
  return axios.get(`api/Selections/getIndustries?keyword=${payload.keyword}&page=${payload.page}`, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchDressCodes = (payload) => {
  return axios.get(`api/Selections/getDressCodes?keyword=${payload.keyword}&page=${payload.page}`, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchCompanySizes = (payload) => {
  return axios.get(`api/Selections/getCompanySizes?keyword=${payload.keyword}&page=${payload.page}`, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchQualifications = (payload) => {
  return axios.get("api/Selections/getQualifications?page=" + payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const createSpecialization = (payload) => {
  return axios.post("api/Selections/createSpecialization", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const createJobType = (payload) => {
  return axios.post("api/Selections/createJobType", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const deleteJobType = (payload) => {
  return axios.post("api/Selections/deleteJobType", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const deleteSpecialization = (payload) => {
  return axios.post("api/Selections/deleteSpecialization", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const createPositionLevel = (payload) => {
  return axios.post("api/Selections/createPositionLevel", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const deletePositionLevel = (payload) => {
  return axios.post("api/Selections/deletePositionLevel", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const createIndustry = (payload) => {
  return axios.post("api/Selections/createIndustry", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const deleteIndustry = (payload) => {
  return axios.post("api/Selections/deleteIndustry", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const createDressCode = (payload) => {
  return axios.post("api/Selections/createDressCode", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const deleteDressCode = (payload) => {
  return axios.post("api/Selections/deleteDressCode", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const createCompanySize = (payload) => {
  return axios.post("api/Selections/createCompanySize", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const deleteCompanySize = (payload) => {
  return axios.post("api/Selections/deleteCompanySize", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const createSpokenLanguage = (payload) => {
  return axios.post("api/Selections/createSpokenLanguage", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const deleteSpokenLanguage = (payload) => {
  return axios.post("api/Selections/deleteSpokenLanguage", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const createQualification = (payload) => {
  return axios.post("api/Selections/createQualification", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const deleteQualification = (payload) => {
  return axios.post("api/Selections/deleteQualification", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchPushNotifications = (payload) => {
  return axios.get(
    "api/PushNotification/getPushNotifications?page=" + payload,
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
    }
  );
};

const fetchTotalPushNotification = (payload) => {
  return axios.get("api/PushNotification/getTotalPushNotification", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const createPushNotification = (payload) => {
  return axios.post("api/PushNotification/SendPushNotification", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchCreditPackageTransactions = (payload) => {
  return axios.get(
    "api/CreditPackages/GetCreditPackageTransactions?page=" + payload,
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
    }
  );
};

const fetchTotalCreditPackageTransaction = (payload) => {
  return axios.get("api/CreditPackages/GetTotalCreditPackageTransaction", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const changePassword = (payload) => {
  return axios.post("api/Account/ChangePassword", payload, {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchEmployersStaticContent = (payload) => {
  return axios.get("api/StaticContent/GetEmployersStaticContent", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchCandidatesStaticContent = (payload) => {
  return axios.get("api/StaticContent/GetCandidatesStaticContent", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchCountries = (payload) => {
  return axios.get("api/Country/GetCountries");
};

const fetchStates = (payload) => {
  return axios.post("api/Country/GetStates", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchDressCodesList = (payload) => {
  return axios.get("api/DressCode/GetDressCodes");
};

const fetchIndustriesList = (payload) => {
  return axios.get("api/Industry/GetIndustries");
};

const fetchCompanySizesList = (payload) => {
  return axios.get("api/CompanySize/GetCompanySizes");
};

const fetchSpokenLanguagesList = (payload) => {
  return axios.get("api/SpokenLanguage/GetSpokenLanguages");
};

const fetchCandidatesTermsAndCondition = (payload) => {
  return axios.get("api/StaticContent/GetCandidateTermsAndCondition", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchEmployersTermsAndCondition = (payload) => {
  return axios.get("api/StaticContent/GetEmployerTermsAndCondition", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const updateCandidatesTermsAndCondition = (payload) => {
  return axios.post(
    "api/StaticContent/updateCandidatesTermsAndCondition",
    payload,
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
    }
  );
};

const updateEmployersTermsAndCondition = (payload) => {
  return axios.post(
    "api/StaticContent/updateEmployerTermsAndCondition",
    payload,
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
    }
  );
};

const fetchCandidatesPrivacyPolicy = (payload) => {
  return axios.get("api/StaticContent/GetCandidatePrivacyPolicy", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const updateCandidatesPrivacyPolicy = (payload) => {
  return axios.post("api/StaticContent/updateCandidatePrivacyPolicy", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const updateEmployersPrivacyPolicy = (payload) => {
  return axios.post("api/StaticContent/updateEmployerPrivacyPolicy", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchEmployersPrivacyPolicy = (payload) => {
  return axios.get("api/StaticContent/GetEmployerPrivacyPolicy", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchCandidatesContactUs = (payload) => {
  return axios.get("api/StaticContent/GetCandidateContactUs", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchEmployersContactUs = (payload) => {
  return axios.get("api/StaticContent/GetEmployerContactUs", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchCandidatesAboutUs = (payload) => {
  return axios.get("api/StaticContent/GetCandidateAboutUs", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchEmployersAboutUs = (payload) => {
  return axios.get("api/StaticContent/GetEmployerAboutUs", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const uploadCandidatesAboutUsBanner = (payload) => {
  return axios.post("api/StaticContent/UploadCandidateAboutUsBanner", payload, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const uploadEmployersAboutUsBanner = (payload) => {
  return axios.post("api/StaticContent/UploadEmployerAboutUsBanner", payload, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const updateCandidatesAboutUs = (payload) => {
  return axios.post("api/StaticContent/UpdateCandidateAboutUs", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const updateEmployersAboutUs = (payload) => {
  return axios.post("api/StaticContent/UpdateEmployerAboutUs", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const updateCandidatesContactUs = (payload) => {
  return axios.post("api/StaticContent/UpdateCandidateContactUs", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const updateEmployersContactUs = (payload) => {
  return axios.post("api/StaticContent/UpdateEmployerContactUs", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchAppVersions = (payload) => {
  return axios.get("api/AppVersion/GetAppVersions?page=" + payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchTotalAppVersion = (payload) => {
  return axios.get("api/AppVersion/GetTotalAppVersion", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const createAppVersion = (payload) => {
  return axios.post("api/AppVersion/CreateAppVersion", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const updateCandidateStatus = (payload) => {
  return axios.post("api/Candidate/UpdateCandidateStatus", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const uploadArticleFile = (payload) => {
  return axios.post("api/Article/UploadArticleFile", payload, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const recommendTalent = (payload) => {
  return axios.post("api/Candidate/RecommendedCandidate", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const uploadEmployerPhotos = (payload) => {
  return axios.post("api/Employers/UploadPhotos", payload, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const createEmployer = (payload) => {
  return axios.post("api/Employers/CreateEmployer", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const updateEmployer = (payload) => {
  return axios.post("api/Employers/UpdateEmployer", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const updateEmployerStatus = (payload) => {
  return axios.post("api/Employers/UpdateEmployerStatus", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const login = (payload) => {
  return axios.post("Token", payload, {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

const fetchStatistics = (payload) => {
  return axios.get("api/Statistics/GetStatistics", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchTotalApplication = (payload) => {
  return axios.get("api/Chart/TotalApplications", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchEmployersFaqs = (payload) => {
  return axios.get("api/StaticContent/GetEmployerFaqs?page=1", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchEmployersFaq = (payload) => {
  return axios.post("api/StaticContent/GetEmployerFaq", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const createEmployersFaq = (payload) => {
  return axios.post("api/StaticContent/CreateEmployerFaq", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const createCandidatesFaq = (payload) => {
  return axios.post("api/StaticContent/CreateCandidateFaq", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const updateEmployersFaq = (payload) => {
  return axios.post("api/StaticContent/UpdateEmployerFaq", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const updateCandidatesFaq = (payload) => {
  return axios.post("api/StaticContent/UpdateCandidateFaq", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const deleteEmployersFaq = (payload) => {
  return axios.post("api/StaticContent/DeleteEmployerFaq", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const deleteCandidatesFaq = (payload) => {
  return axios.post("api/StaticContent/DeleteCandidateFaq", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchCandidatesFaqs = (payload) => {
  return axios.get("api/StaticContent/GetCandidateFaqs?page=1", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchCandidatesFaq = (payload) => {
  return axios.post("api/StaticContent/GetCandidateFaq", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchJobApplicationsByUserId = (payload) => {
  return axios.post("api/JobApplications/GetJobApplicationsByUserId", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchCompanies = (payload) => {
  return axios.get("api/JobApplications/GetCompanies", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const updateCompanyCredit = (payload) => {
  return axios.post("api/CreditPackages/TopUpCredit", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchJobAdvertisements = (payload) => {
  return axios.get("api/JobAdvertisement/GetJobAdvertisements", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const fetchJobAdvertisementsByCompanyId = (payload) => {
  return axios.get(
    "api/JobAdvertisement/GetJobAdvertisementsByCompanyId?" + payload,
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
    }
  );
};

const fetchSpecializationList = (payload) => {
  return axios.get("api/Specialization/GetSpecializations", {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const updateIndustry = (payload) => {
  return axios.post("api/Selections/updateIndustry", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const updateDressCode = (payload) => {
  return axios.post("api/Selections/updateDressCode", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const updateCompanySize = (payload) => {
  return axios.post("api/Selections/updateCompanySize", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const updateSpokenLanguage = (payload) => {
  return axios.post("api/Selections/updateSpokenLanguage", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const updateQualification = (payload) => {
  return axios.post("api/Selections/updateQualification", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const updateJobType = (payload) => {
  return axios.post("api/Selections/updateJobType", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const updateSpecialization = (payload) => {
  return axios.post("api/Selections/updateSpecialization", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const updatePositionLevel = (payload) => {
  return axios.post("api/Selections/updatePositionLevel", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

const updatePackageStatus = (payload) => {
  return axios.post("api/CreditPackage/updateStatus", payload, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  });
};

export default {
  login,
  updatePackageStatus,
  fetchSpecializationList,
  fetchJobAdvertisements,
  fetchJobAdvertisementsByCompanyId,
  updateCompanyCredit,
  fetchJobApplicationsByUserId,
  fetchCompanies,
  fetchCandidatesFaqs,
  fetchCandidatesFaq,
  createCandidatesFaq,
  updateCandidatesFaq,
  deleteCandidatesFaq,
  fetchStatistics,
  deleteEmployersFaq,
  updateEmployersFaq,
  fetchEmployersFaqs,
  fetchEmployersFaq,
  createEmployersFaq,
  fetchTotalApplication,
  createEmployer,
  uploadEmployerPhotos,
  uploadArticleFile,
  fetchAppVersions,
  createAppVersion,
  fetchTotalAppVersion,
  fetchJobApplications,
  fetchJobApplication,
  fetchTotalJobApplicationByStatus,
  fetchTalents,
  fetchEmployees,
  fetchTotalEmployee,
  fetchEmployee,
  fetchTotalEmployer,
  fetchEmployers,
  fetchEmployer,
  createPackage,
  updatePackage,
  deletePackage,
  changePassword,
  fetchArticles,
  fetchArticle,
  createArticle,
  updateArticle,
  deleteArticle,
  fetchPositionLevels,
  fetchIndustries,
  fetchTotalArticles,
  fetchTotalSpecialization,
  fetchTotalPositionLevel,
  fetchTotalIndustry,
  fetchTotalDressCode,
  fetchTotalCompanySize,
  fetchTotalSpokenLanguage,
  fetchTotalQualification,
  fetchSpecializations,
  fetchSpokenLanguages,
  fetchDressCodes,
  fetchCompanySizes,
  fetchQualifications,
  createSpecialization,
  createPositionLevel,
  deletePositionLevel,
  createIndustry,
  createDressCode,
  createCompanySize,
  createSpokenLanguage,
  createQualification,
  fetchPushNotifications,
  fetchTotalPushNotification,
  createPushNotification,
  fetchCreditPackageTransactions,
  fetchTotalCreditPackageTransaction,
  fetchCreditPackage,
  fetchTotalCreditPackage,
  fetchEmployersStaticContent,
  fetchCandidatesStaticContent,
  fetchCountries,
  fetchStates,
  fetchDressCodesList,
  fetchIndustriesList,
  fetchCompanySizesList,
  fetchSpokenLanguagesList,
  fetchCandidatesTermsAndCondition,
  fetchCandidatesPrivacyPolicy,
  fetchEmployersPrivacyPolicy,
  fetchCandidatesContactUs,
  updateCandidatesTermsAndCondition,
  fetchCandidatesAboutUs,
  uploadCandidatesAboutUsBanner,
  updateCandidatesAboutUs,
  updateCandidatesContactUs,
  updateCandidateStatus,
  deleteSpecialization,
  deleteIndustry,
  deleteDressCode,
  deleteCompanySize,
  deleteSpokenLanguage,
  deleteQualification,
  fetchEmployersTermsAndCondition,
  fetchEmployersContactUs,
  fetchEmployersAboutUs,
  uploadEmployersAboutUsBanner,
  updateEmployersAboutUs,
  updateEmployersContactUs,
  updateEmployersTermsAndCondition,
  updateCandidatesPrivacyPolicy,
  updateEmployersPrivacyPolicy,
  recommendTalent,
  updateEmployerStatus,
  updateEmployer,
  fetchCreditPackages,
  fetchCreditPackagesList,
  fetchPendingEmployer,
  fetchTotalJobType,
  createJobType,
  deleteJobType,
  fetchJobTypes,
  updateIndustry,
  updateDressCode,
  updateCompanySize,
  updateSpokenLanguage,
  updateQualification,
  updateJobType,
  updateSpecialization,
  updatePositionLevel,
  fetchActiveCreditPackages,
};
